import React from 'react'
import { Container, Row, Col, Image } from "react-bootstrap";

export default function Footer() {
  return (
    <Container fluid className="footerContainer px-0">
      <Row className="justify-content-center footerRow py-md-2 py-lg-3 mx-auto">
        <Col xs={12} md={5}className="footerLeft ">
          <h3>East Village Landscaping</h3>
          <h4>contact@eastvillagelandscaping.com</h4>
          <h4>Springfield, MA 01108</h4>
          <p className="footerServiceAreas">Serving Springfield, East Longmeadow, Longmeadow, Wilbraham, Hampden &amp; West Springfield, MA</p>
          <h5>413-736-5168</h5>
        </Col>
        <Col xs={12} md={2} className="gaurenteeCol ">
          <Image className="gaurenteeImg mx-auto" src={require("../../images/gaurentee.png")}></Image>
        </Col>
        <Col xs={12} md={5}className="footerRight">
          <h5>Accepted Payment</h5>
          <div className="payments">
          <i className="fab fa-cc-visa"></i>
          <i className="fab fa-cc-mastercard"></i>
          <i className="fab fa-cc-discover"></i>
          <i className="fab fa-cc-amex"></i>
          <i className="fas fa-money-bill"></i>
          <i className="fas fa-money-check"></i>
          </div>
          
          <h4>© 2021 East Village Landscaping </h4>
          <h5>Design by J.Ogoley</h5>
        </Col>
      </Row>
    </Container>
  )
}
